import { createAction, props } from '@ngrx/store';
import { WorkflowEmailTemplate } from './workflow-email-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records workflow email template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records workflow email template success', 
    props<{ listData: WorkflowEmailTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records workflow email template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflow email template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflow email template success', 
    props<{ singleData: WorkflowEmailTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflow email template failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record workflow email template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record workflow email template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record workflow email template failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state workflow email template',
);